import '@babel/polyfill'
;(window as any).vue = Vue
import store from '@/common/store'
import Vue from 'vue'
import VueRouter from 'vue-router'
import './../plugins/antDesign'
import App from './App.vue'

export function getRootVue(params: any) {
  let {
    router
  }: {
    router: VueRouter
  } = params
  // const router = get
  return new Vue({
    router,
    store,
    render: (h) => h(App)
  }).$mount('#app')
}
